import React, {useContext} from 'react'
import { Typography, FormControlLabel, Radio } from '@mui/material'
import { Trans } from 'react-i18next'
import productTypeIsOneOf from '../../../lib/productTypeIsOneOf'
import { ComplaintState, ProductTypeOptions } from '../../../contexts/types'
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type FitOptionsProps = {
    productType: ProductTypeOptions
    complaint: ComplaintState
}

const FitOptions: React.FC<FitOptionsProps> = ({ productType, complaint }) => {
    const eventOccurrence = complaint.complaintType.location
    const { t, tns } = useContext(OrgCustomizationContext)

    return (
        <>
            {/* Fit */}
            <Typography
                variant='body1'
                color='secondary.contrastText'
                sx={{ pt: 2 }}
            >
                <Trans i18nKey={tns('cti_complaint_fit')}>
                    -
                    <Typography component='span' sx={{ color: 'primary.main' }}>
                        -
                    </Typography>
                    -
                </Trans>
            </Typography>

            {productTypeIsOneOf(
                ['CLINICAL_INSTRUMENT', 'LAB_INSTRUMENT_LAB_SCREW'],
                productType
            ) && (
                <FormControlLabel
                    value='FUNCTIONALITY_COMPROMISED'
                    control={<Radio />}
                    label={t('cti_option_functionality_compromised') as string}
                />
            )}

            {productTypeIsOneOf(['ABUTMENT', 'SCREW'], productType) &&
                (eventOccurrence === '4_CLINIC_DURING_PROCEDURE' ||
                    eventOccurrence === '5_CLINIC_AFTER_PROCEDURE') && (
                    <FormControlLabel
                        value='CLINICAL_PROSTHETIC_SCREW_LOOSENING'
                        control={<Radio />}
                        label={
                            t(
                                'cti_option_clinical_prosthetic_screw_loosening'
                            ) as string
                        }
                    />
                )}

            {productTypeIsOneOf(
                [
                    'ABUTMENT',
                    'SCREW',
                    'CLINICAL_INSTRUMENT',
                    'LAB_INSTRUMENT_LAB_SCREW',
                ],
                productType
            ) && (
                <FormControlLabel
                    value='PART_DISASSEMBLY_ISSUE'
                    control={<Radio />}
                    label={t('cti_option_part_disassembly_issue') as string}
                />
            )}

            {productTypeIsOneOf(
                [
                    'ABUTMENT',
                    'SCREW',
                    'CLINICAL_INSTRUMENT',
                    'LAB_INSTRUMENT_LAB_SCREW',
                ],
                productType
            ) && (
                <FormControlLabel
                    value='PART_ASSEMBLY_ISSUE'
                    control={<Radio />}
                    label={t('cti_option_part_assembly_issue') as string}
                />
            )}

            <FormControlLabel
                value='PART_NOT_RETAINED'
                control={<Radio />}
                label={t('cti_option_part_not_retained') as string}
            />
            <FormControlLabel
                value='DOES_NOT_ENGAGE'
                control={<Radio />}
                label={t('cti_option_does_not_engage') as string}
            />
            <FormControlLabel
                value='DOES_NOT_DISENGAGE'
                control={<Radio />}
                label={t('cti_option_does_not_disengage') as string}
            />
            <FormControlLabel
                value='DOES_NOT_FIT'
                control={<Radio />}
                label={t('cti_option_does_not_fit') as string}
            />
        </>
    )
}

export default FitOptions
